class PubSub extends EventTarget {
  private listenersMap: Map<any, any> = new Map();
  public subscribe(context: string, callback: (data: any) => void) {
    const eventListenerCallback = (evt: CustomEvent<any>) => {
      callback(evt.detail);
    };

    // @ts-ignore
    this.addEventListener(context, eventListenerCallback);
    this.listenersMap.set(callback, eventListenerCallback);
  }
  public unsubscribe(context: string, callback: (event: any) => void) {
    const eventListenerCallback = this.listenersMap.get(callback);
    this.removeEventListener(context, eventListenerCallback);
  }
  public publish(context: string, event?: any) {
    this.dispatchEvent(new CustomEvent(context, { detail: event }));
  }
}
const pubSub = new PubSub();
export { pubSub };

export enum CUSTOM_EVENT_NAMES {
  CHECK_FOR_IS_LIVE = 'checkForIsLive',
  SEEK_DURATION_UPDATE = 'seekDurationUpdate',
  VIDEO_QUALITY_CHANGE = 'videoQualityChange',
  USOCKET_TIME_OUT = 'usocketTimeOut',
  HLS_TIME_UPDATE = 'hlsTimeUpdate',
  GOT_FIREBASE_CONFIG = 'gotFirebaseConfig',
  VERNACULAR_LANGUAGE_CHANGE = 'vernacularLanguageChange',
  UPDATE_LANGUAGE_TRACKS = 'updateLanguageTracks',
  GOT_VIDEO_COPILOT_ONBOARDING_CONFIG = 'gotVideoCopilotOnboardingConfig',
  VIDEO_COPILOT_ANNOTATION_STATE_CHANGE = 'videoCopilotAnnotationStateChange',
  VIDEO_COPILOT_INPUT_STATE_CHANGE = 'videoCopilotInputStateChange',
}
